<template>
    <!-- Ionic modal provides --max-height -->
    <div class="pt-4 pb-(--beyond-safe-area-inset-bottom) h-(--max-height) flex flex-col">
        <ModalHeader @close="cancel">
            {{ title }}
        </ModalHeader>
        <IonContent class="flex-1">
            <ModuleComponents :modules="modalComponents" />
        </IonContent>
    </div>
</template>
<script setup>
    import { modalController } from '@ionic/vue'
    import ModuleComponents from '@/components/ModuleComponents.vue'

    const props = defineProps({
        modal: Object,
    })

    const title = computed(() => {
        return props.modal.title
    })

    const modalComponents = computed(() => {
        return props.modal.items
    })

    const cancel = () => {
        modalController.dismiss(null, 'cancel')
    }
</script>
